module.exports = __webpack_public_path__ + "img/urbi.11949bb1.png";